import { Container } from './styled';
import { TextProps } from './types';

export default function Text(textProps: TextProps) {
  const { value, fontColor, fontSize, fontWeight, fontAlign, lineCount } =
    textProps;

  return (
    <Container
      $fontWeight={fontWeight}
      $fontColor={fontColor}
      $fontSize={fontSize}
      $fontAlign={fontAlign}
      $lineCount={lineCount}
    >
      {value}
    </Container>
  );
}
